import "./Accommodations.module.css";
import Header from "@/reusable_sections/Header";
import PremiumPostnatalPricing from "./sections/PremiumPostnatalPricing";
import ServicesOverview from "./sections/ServicesOverview";
import SimpleProcess from "./sections/SimpleProcess";
import IsabelTestimonial from "./sections/IsabelTestimonial";
import PathwayOrientation from "./sections/PathwayOrientation";
import PostpartumPackages from "./sections/PostpartumPackages";
import PostpartumSupportCta from "./sections/PostpartumSupportCta";
import Footer from "@/reusable_sections/Footer";
import GiftCard from "./sections/GiftCard";
import IncludedServices from "./sections/IncludedServices";
export default function AccommodationsPage() {
  return <div>
      <Header />
      <PremiumPostnatalPricing />
      <ServicesOverview />
      <PostpartumSupportCta />
      <SimpleProcess />
      <PostpartumPackages />
      <IncludedServices />
      <IsabelTestimonial />
      <PathwayOrientation />
      <GiftCard />
      <Footer />
    </div>;
}